import Horn from '@mtfe/horn-sdk';
import {env} from '@/common/env';

export function getConfigFromHorn(key: string, defaultValue: any = {}): Promise<any> {
  return new Promise((resolve) => {
    Horn.init(
      {},
      {
        isDev: env.runtime > 1,
      }
    );
    Horn.fetch(
      key,
      {},
      defaultValue
    ).then((config: any) => {
      resolve(config);
    }).catch(() => {
      resolve(defaultValue);
    });
  });
}
